import { SvgComponentProps, Svg } from './svg-component';

export const BoltFillIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 16} height={size || 16} viewBox="0 0 16 16" fill="none" {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.288.02a.57.57 0 0 1 .423.55v5.144h4.43a.57.57 0 0 1 .493.856l-5.286 9.142a.57.57 0 0 1-1.063-.285v-5.144h-4.43a.57.57 0 0 1-.493-.855L7.647.285a.57.57 0 0 1 .641-.266Z"
            fill="currentColor"
        />
    </Svg>
);
